import { createServerFn } from "@tanstack/react-start";
import z from "zod";

import { USERS_COLUMNS, USER_ROLES } from "@onesolution/constants";
import { authMiddleware } from "@onesolution/middlewares";
import { rolesCheck } from "@onesolution/middlewares/rolesCheck";

import type { MONDAY_TYPES } from "@onesolution/monday";
import { mondayClient } from "@onesolution/monday/monday";
import { wrapWithUseQuery } from "..";

const paramsSchema = z.object({
	id: z.string(),
});

const handler = createServerFn()
	.middleware([authMiddleware, rolesCheck([USER_ROLES.Admin])])
	.validator(paramsSchema)
	.handler(async ({ data }) => {
		const [user] = await mondayClient.query.items<{
			active: MONDAY_TYPES["checkbox"];
			firstname: MONDAY_TYPES["text"];
			lastname: MONDAY_TYPES["text"];
			name: MONDAY_TYPES["text"];
			status: MONDAY_TYPES["status"];
			favoriteServices: { linked_item_ids: string[]; display_value: string };
			services: { linked_item_ids: string[]; display_value: string };
			language: MONDAY_TYPES["dropdown"];
		}>({
			columnIds: [
				USERS_COLUMNS.lastname,
				USERS_COLUMNS.firstname,
				USERS_COLUMNS.email,
				USERS_COLUMNS.role,
				USERS_COLUMNS.services,
				USERS_COLUMNS.favoriteServices,
				USERS_COLUMNS.language,
				USERS_COLUMNS.active,
			],
			itemIds: [data.id],
		});

		return {
			...user,
			email: user.name,
			role: user.status.label,
			language: user.language[0]?.label,
			favoriteServices: user.favoriteServices.linked_item_ids,
			services: user.services.linked_item_ids,
		};
	});

export const getUserByIdFromServer = wrapWithUseQuery("userById", handler);

export type UserById = Awaited<ReturnType<typeof getUserByIdFromServer>>;
